import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  HcpServiceState,
  Service,
  UpdateServicePayload,
} from '../types/hcpServiceRequested.types'

const initialState: HcpServiceState = {
  services: [],
  loading: false,
  error: null,
  updateLoading: false,
  updateError: null,
}

const hcpServiceSlice = createSlice({
  name: 'hcpServices',
  initialState: initialState,
  reducers: {
    fetchServicesRequest: (state) => {
      state.loading = true
      state.error = null
    },
    fetchServicesSuccess: (state, action) => {
      state.services = action.payload
      state.loading = false
    },
    fetchServicesFailure: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    updateServicesRequest: (
      state,
      _action: PayloadAction<UpdateServicePayload[]>
    ) => {
      state.updateLoading = true
      state.updateError = null
    },

    updateServicesSuccess: (state, action: PayloadAction<Service[]>) => {
      state.services = action.payload
      state.updateLoading = false
    },
    updateServicesFailure: (state, action: PayloadAction<string>) => {
      state.updateError = action.payload
      state.updateLoading = false
    },
  },
})

export const {
  fetchServicesRequest,
  fetchServicesSuccess,
  fetchServicesFailure,
  updateServicesRequest,
  updateServicesSuccess,
  updateServicesFailure,
} = hcpServiceSlice.actions

export default hcpServiceSlice.reducer
